import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

const Disclaimer = styled.p`
  font-size: 0.8rem;
  margin-top: 2rem;
`;

export const NutritionDisclaimer = () => {
  const { formatMessage } = useIntl();
  return (
    <Disclaimer data-testid="nutrition-disclaimer-th">
      {formatMessage({ id: 'nutritionDisclaimer' })}
    </Disclaimer>
  );
};
